import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

@Directive({
    selector: '[mzPassEqual]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: MzPassEqualDirective,
        multi: true
    }]
})
export class MzPassEqualDirective implements Validator {

    @Input() mzPassEqual: string;

    validate(control: AbstractControl): ValidationErrors | null {
        if (this.mzPassEqual && control.value !== this.mzPassEqual) {
            return {pattern: 'Пароли не совпадают'};
        } else {
            return null;
        }
    }
}
